/**
 * Who can create, edit, and enable/disable dealer self sign-up links.
 *
 * `/self-signup-customer` is registered only for the Partner portal. Administrators
 * manage the same links from a partner company. Other portals do not.
 */
export function canManageSignupLinks(portal = readSession("selectedPortal")) {
  return portal === "Partner" || portal === "Administrator";
}

/**
 * Company id for POST /v1/partner/generate-signup-link.
 * The self sign-up route does not pass `selectedCompany`; the active dealer
 * company is stored in sessionStorage by the company switcher.
 */
export function resolvePartnerCompanyId(selectedCompany) {
  if (selectedCompany) return selectedCompany;
  return readSession("selectedCompany");
}

function readSession(key) {
  try {
    return sessionStorage.getItem(key) || null;
  } catch (error) {
    return null;
  }
}
